/* Sparkle burst when a product is added to the cart (Theme settings > Add to cart sparkle).
   The theme adds to cart from several scripts (product form, custom.js via jQuery,
   haldiram-enhancements.js, bundles), so this watches the network instead of each button:
   any successful POST to /cart/add sparkles at the button that was just clicked,
   or at the header cart icon if that button is gone. */
(function () {
  if (window.__cartSparkle) return;
  window.__cartSparkle = true;

  const COLORS = ['#cd9951', '#f2c46d', '#922637', '#7f5b98'];
  const PARTICLES = 14;
  const CLICK_MEMORY_MS = 8000;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let lastTrigger = null;
  let lastTriggerAt = 0;
  // Where the button was when clicked: tile buttons hide themselves once the quantity stepper shows.
  let lastTriggerRect = null;
  let lastScroll = { x: 0, y: 0 };

  // Remember the last button or link the shopper used, to place the sparkle there.
  document.addEventListener(
    'click',
    (event) => {
      const el = event.target.closest('button, [type="submit"], [type="button"], a, [role="button"]');
      if (!el) return;
      lastTrigger = el;
      lastTriggerAt = Date.now();
      lastTriggerRect = el.getBoundingClientRect();
      lastScroll = { x: window.scrollX, y: window.scrollY };
    },
    true
  );

  function isCartAdd(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    try {
      return /\/cart\/add(\.js)?$/.test(new URL(url, window.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function onScreen(rect) {
    return rect && rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function originRect() {
    if (lastTrigger && Date.now() - lastTriggerAt < CLICK_MEMORY_MS) {
      const now = lastTrigger.isConnected && lastTrigger.getBoundingClientRect();
      if (onScreen(now)) return now;
      const r = lastTriggerRect;
      const then = r && new DOMRect(r.x + lastScroll.x - window.scrollX, r.y + lastScroll.y - window.scrollY, r.width, r.height);
      if (onScreen(then)) return then;
    }
    const cartIcon = document.getElementById('cart-icon-bubble');
    const rect = cartIcon && cartIcon.getBoundingClientRect();
    return onScreen(rect) ? rect : null;
  }

  function sparkle() {
    if (reduceMotion.matches) return;
    const rect = originRect();
    if (!rect) return;

    const burst = document.createElement('div');
    burst.className = 'cart-sparkle';
    burst.setAttribute('aria-hidden', 'true');
    burst.style.left = `${rect.left + rect.width / 2}px`;
    burst.style.top = `${rect.top + rect.height / 2}px`;
    document.body.appendChild(burst);

    const reach = Math.max(48, Math.min(rect.width * 0.75, 110));
    const animations = [];
    for (let i = 0; i < PARTICLES; i++) {
      const star = document.createElement('span');
      star.className = 'cart-sparkle__star';
      const size = 8 + Math.random() * 10;
      star.style.width = star.style.height = `${size}px`;
      star.style.color = COLORS[i % COLORS.length];
      burst.appendChild(star);

      const angle = (Math.PI * 2 * i) / PARTICLES + (Math.random() - 0.5) * 0.5;
      const distance = reach * (0.6 + Math.random() * 0.5);
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;
      const spin = (Math.random() - 0.5) * 360;

      animations.push(
        star.animate(
          [
            { transform: 'translate(-50%, -50%) scale(0) rotate(0deg)', opacity: 1 },
            {
              transform: `translate(calc(-50% + ${x * 0.7}px), calc(-50% + ${y * 0.7}px)) scale(1.1) rotate(${spin / 2}deg)`,
              opacity: 1,
              offset: 0.55,
            },
            {
              transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(0.2) rotate(${spin}deg)`,
              opacity: 0,
            },
          ],
          { duration: 650 + Math.random() * 250, delay: Math.random() * 80, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }
        ).finished
      );
    }

    Promise.all(animations)
      .catch(() => {})
      .then(() => burst.remove());
  }

  const nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      const request = nativeFetch.apply(this, arguments);
      const url = input instanceof Request ? input.url : input;
      const method = (init && init.method) || (input instanceof Request ? input.method : 'GET');
      if (isCartAdd(url, method)) {
        request.then((response) => response.ok && sparkle()).catch(() => {});
      }
      return request;
    };
  }

  // jQuery $.ajax calls in custom.js go through XMLHttpRequest.
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAdd(url, method)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) sparkle();
      });
    }
    return nativeOpen.apply(this, arguments);
  };
})();
